import styled from "styled-components";
import PropTypes from "prop-types";
import { device } from "../device";

const Paragraph = styled.p`

    margin: ${({space}) => 
        (space === 'Top' && '40px 0 0') ||
        (space === 'TopDown' && '40px 0 24px') || 
        (space === 'Down' && '0 0 24px') ||
        '0'
    };

    @media ${device.lg} {
        margin: ${({space}) => 
            (space === 'Top' && '48px 0 0') ||
            (space === 'TopDown' && '48px 0 32px') || 
            (space === 'Down' && '0 0 32px')
        };
    }
`;

Paragraph.propTypes = {
    space: PropTypes.string
};

export default Paragraph